const footer = {
    phoneLabel: 'Tel',
    emailLabel: 'Email'
  };

export default footer;
